// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"fa437de7","989":"c9ac4960"}[chunkId] + ".chunk.js";
};